import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ExpandableContext } from '@components/contexts';
import Counts from './Counts';
import Filters from './Filters';
import Title from './Title';
import SubMenu from './SubMenu';

const Header = (props) => {
	const {
		hideDeleteButton,
		hideDateRange,
		pageName,
		activePage,
	} = props;

	return (
		<React.Fragment>
			<Title activePage={activePage} />
			<Counts />
			<div className="container margin-top-30">
				<ExpandableContext.Provider initiallyExpanded>
					<SubMenu
						hideDeleteButton={hideDeleteButton}
						activePage={activePage}
						label={pageName}
					/>
					<ExpandableContext.Consumer>
						{({ expanded }) => (
							<div className={classNames('search-bar payments-page expandable border-top-0', { expanded })}>
								<Filters hideDateRange={hideDateRange} activePage={activePage} />
							</div>
						)}
					</ExpandableContext.Consumer>
				</ExpandableContext.Provider>
			</div>
		</React.Fragment>
	);
};

Header.propTypes = {
	activePage       : PropTypes.string,
	hideDateRange    : PropTypes.bool,
	hideDeleteButton : PropTypes.bool,
	pageName         : PropTypes.string,
};

Header.defaultProps = {
	hideDeleteButton : false,
	hideDateRange    : false,
	activePage       : '',
	pageName         : '',
};
export default Header;
